<div class="modal-header">
	<h5 class="modal-title">Neuigkeiten</h5>
	<button type="button" class="btn-close" aria-label="Schließen" (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body changelog-body">
	<div *ngFor="let version of versions; let first = first" class="version-block" [class.first]="first">
		<div class="version-header">
			<span class="version-number">Version {{ version.version }}</span>
			<span class="version-date">{{ formatDate(version.date) }}</span>
		</div>
		<ul class="changes-list">
			<li *ngFor="let change of version.changes" class="change-item">
				<span class="change-icon">{{ cs.getTypeIcon(change.type) }}</span>
				<span class="change-text">{{ change.text }}</span>
			</li>
		</ul>
	</div>
</div>
<div class="modal-footer">
	<button type="button" class="btn btn-primary" (click)="activeModal.close()">Schließen</button>
</div>
